import React from 'react';

function Portfolio() {
  return (
    <div className="work-metro work-tooltip section-padding pt-0 sub-bg">
      <div className="container-xl">
        <div className="row xxlg-marg justify-content-between">
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/1.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/2.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/3.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/4.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/5.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/6.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/7.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div
                className="img position-re"
                data-tooltip-tit="Work image"
                data-tooltip-sub="Design"
              >
                <img src="/light/assets/imgs/works/stand/8.jpg" alt="" />
                <a href="/light/project1" className="plink"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
